package com.yogaaicoach.common.network

import Config
import com.yogaaicoach.pages.auth.TokenDataManager
import io.github.aakira.napier.Napier
import io.ktor.client.*
import io.ktor.client.call.*
import io.ktor.client.plugins.*
import io.ktor.client.plugins.contentnegotiation.*
import io.ktor.client.request.*
import io.ktor.client.statement.*
import io.ktor.http.*
import io.ktor.serialization.kotlinx.json.*
import kotlinx.coroutines.CancellationException
import kotlinx.serialization.Serializable
import kotlinx.serialization.json.Json
import kotlin.time.Clock
import kotlin.time.ExperimentalTime

@Serializable
data class TokenResponse(
    val access_token: String,
    val expires_in: String,
    val token_type: String,
    val refresh_token: String,
    val id_token: String,
    val user_id: String,
    val project_id: String
)

// TODO prolly should be service?
class ApiClient {
    val publicClient = HttpClient() {
        install(ContentNegotiation) {
            json()
        }
    }

    // TODO make private it shouldn't be used without make request wrapper
    val client = HttpClient() {
        install(ContentNegotiation) {
            json(Json {
                explicitNulls = false
                ignoreUnknownKeys = true
            })
        }
        install(AuthRetryPlugin) {
            // Retry conditions
            retryIf { request, response ->
                hasNewAccessToken(response)
            }
            modifyRequest { request ->
                request.headers[HttpHeaders.Authorization] = "Bearer ${TokenDataManager.tokenData!!.accessToken}"
            }
        }
        install(DefaultRequest) {
            headers {
                append(HttpHeaders.Authorization, "Bearer ${TokenDataManager.tokenData?.accessToken}")
            }
            contentType(ContentType.Application.Json)
        }
    }

    @OptIn(ExperimentalTime::class)
    private suspend fun hasNewAccessToken(response: HttpResponse): Boolean {
        if (response.status != HttpStatusCode.Unauthorized) {
            return false
        }
        val refreshToken = TokenDataManager.tokenData?.refreshToken ?: return false
        val tokenResponse = getNewToken(refreshToken) ?: return false

        TokenDataManager.initialize(
            accessToken = tokenResponse.access_token,
            idToken = tokenResponse.id_token,
            refreshToken = tokenResponse.refresh_token,
            expirationTimestampMs = (tokenResponse.expires_in.toLong() + Clock.System.now().epochSeconds) * 1000
        )
        return true
    }

    suspend fun fetchData(accessToken: String): HttpResponse {
        val response = client.get("${Config.API_URL}/api/hello"){
            headers {
                append(HttpHeaders.Authorization, "Bearer ${accessToken}")
            }
        }
        return response
    }

    suspend fun getNewToken(refreshToken: String): TokenResponse? {
        try {
            val response = publicClient.post("https://securetoken.googleapis.com/v1/token?key=${Config.API_KEY}") {
                contentType(ContentType.Application.Json)
                setBody(mapOf(
                    "grant_type" to "refresh_token",
                    "refresh_token" to refreshToken
                ))
            }
            return response.body()
        } catch (e: Exception) {
            return null // Refresh token probably expired
        }
    }

    // TODO add some generic error class as response instead of Null
    suspend inline fun <reified T> makeRequest(
        url: String,
        method: HttpMethod = HttpMethod.Get,
        body: Any? = null
    ): T? {
        return try {
            val response: HttpResponse = client.request(url) {
                this.method = method
                if (body != null) {
                    setBody(body)
                }
            }
            if (response.status.isSuccess()) {
                response.body()
            } else {
                null
            }
        } catch (e: CancellationException) {
            Napier.d("CancellationException debug: $url")
            null
        } catch (e: Exception) {
            Napier.d("Exception debug: $url")
            Napier.e("Exception: ${e.message}")
            null
        }
    }
}


